import permissionMiddleware from "@/router/middlewares/permissionMiddleware";
import authMiddleware from "@/router/middlewares/authMiddleware";
import { PERMISSIONS } from "@/utils/constants";

export default [
  {
    path: "/team",
    component: () => import("../pages/admin/team/index"),
    name: "team-index",
    meta: {
      middleware: [authMiddleware, permissionMiddleware(PERMISSIONS.REFERENCE)],
    },
  },
  {
    path: "/team/create",
    component: () => import("../pages/admin/team/item"),
    name: "team-create",
    meta: {
      middleware: [authMiddleware, permissionMiddleware(PERMISSIONS.REFERENCE)],
    },
  },
  {
    path: "/team/:id",
    component: () => import("../pages/admin/team/item"),
    props: true,
    name: "team-edit",
    meta: {
      middleware: [authMiddleware, permissionMiddleware(PERMISSIONS.REFERENCE)],
    },
  },
];
